import styled from "styled-components"

export const FormSection = styled.div`
  margin-bottom: 2rem;
`

export const FormLabel = styled.label`
  display: block;
  font-size: 1.2rem;
  ${(p) => p.theme.bold};
  color: ${(p) => p.theme.colors.greyDarker};
  margin-bottom: 0.5rem;
`

export const SelectWrapper = styled.div`
  margin-bottom: 1.5rem;

  select {
    width: 100%;
    padding: 0.8rem 1rem;
    border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
    border-radius: 0.4rem;
    font-size: 1.3rem;
    background: ${(p) => p.theme.colors.white};
  }
`

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.8rem 1rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  font-size: 1.2rem;
  font-family: monospace;
  background: ${(p) => p.theme.colors.white};
  min-height: 12rem;
  resize: vertical;
  box-sizing: border-box;
`

export const HelperText = styled.div`
  background: ${(p) => p.theme.colors.greyLighter};
  border-radius: 0.4rem;
  padding: 1rem 1.2rem;
  font-size: 1.1rem;
  line-height: 1.6;
  color: ${(p) => p.theme.colors.greyDarker};
  margin-bottom: 1.5rem;

  strong {
    display: block;
    margin-bottom: 0.4rem;
    font-size: 1.2rem;
  }

  code {
    background: ${(p) => p.theme.colors.white};
    padding: 0.1rem 0.4rem;
    border-radius: 0.3rem;
    font-size: 1.1rem;
  }

  pre {
    background: ${(p) => p.theme.colors.white};
    padding: 0.8rem;
    border-radius: 0.3rem;
    font-size: 1rem;
    line-height: 1.4;
    overflow-x: auto;
    margin: 0.6rem 0;
    white-space: pre;
  }
`

export const ValueListRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.8rem;

  input {
    flex: 1;
    padding: 0.8rem 1rem;
    border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
    border-radius: 0.4rem;
    font-size: 1.3rem;
    background: ${(p) => p.theme.colors.white};
  }
`

export const RemoveValueButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  color: ${(p) => p.theme.colors.greyDark};
  font-size: 1.6rem;
  line-height: 1;

  &:hover {
    color: ${(p) => p.theme.colors.errorText};
  }
`

export const AddValueButton = styled.button`
  background: none;
  border: 0.1rem dashed ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  padding: 0.6rem 1rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.turquoiseDark};
  cursor: pointer;
  width: 100%;
  ${(p) => p.theme.bold};

  &:hover {
    border-color: ${(p) => p.theme.colors.turquoiseDark};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const DeleteNodeButton = styled.button`
  background: transparent;
  border: none;
  color: ${(p) => p.theme.colors.errorText};
  cursor: pointer;
  ${(p) => p.theme.bold};
  font-size: 1.3rem;
`

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  padding: 0.4rem 0;
  font-size: 1.3rem;
  color: ${(p) => p.theme.colors.black};

  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 1.8rem;
    height: 1.8rem;
    border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
    border-radius: 0.3rem;
    background: ${(p) => p.theme.colors.white};
    cursor: pointer;
    position: relative;
    flex-shrink: 0;
    margin: 0;
    transition: all 0.15s ease;

    &:hover {
      border-color: ${(p) => p.theme.colors.turquoiseDark};
    }

    &:checked {
      background: ${(p) => p.theme.colors.turquoiseDark};
      border-color: ${(p) => p.theme.colors.turquoiseDark};
    }

    &:checked::after {
      content: "";
      position: absolute;
      top: 0.1rem;
      left: 0.5rem;
      width: 0.4rem;
      height: 0.9rem;
      border: solid ${(p) => p.theme.colors.white};
      border-width: 0 0.2rem 0.2rem 0;
      transform: rotate(45deg);
    }
  }
`

export const SaveButton = styled.button`
  width: 100%;
  padding: 1rem;
  background: ${(p) => p.theme.colors.turquoiseDark};
  color: ${(p) => p.theme.colors.white};
  border: none;
  border-radius: 0.4rem;
  font-size: 1.4rem;
  cursor: pointer;
  ${(p) => p.theme.bold};
  margin-top: 2rem;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`
